<section id="layout-top" class="section-allies">
  <app-modal-out-jelpit [modalData]="customModal" [allyOb]="selectedAlly" [selectedCategoryOb]="selectedCategory" [selectedOriginInput]="selectedOrigin"></app-modal-out-jelpit>
  <div class="heading">
    <h1>Jelpit aliados</h1>
    <p>Encuentra tu aliado por categoría.</p>
  </div>
  <div class="top-filters container_slick" id="menu-categories">
    <div class="container_items">
      <swiper #swiper class="carousel" [config]="slideConfig">
        <ng-template
          swiperSlide
          *ngFor="let ally of filterCategories; let i = index"
          class="slide"
        >
          <a
            [ngClass]="{ selected: i === selectedServiceIndex }"
            (click)="selectService(i)"
            >{{ ally.name }}
            <span class="color" [style.background]="ally.color_hex"> </span>
          </a>
        </ng-template>
      </swiper>
    </div>
  </div>
  <div
    class="container_content"
    *ngFor="let category of renderCategories; let iCat = index"
    id="{{ category.name }}"
    (window:scroll)="scroll(category.name, iCat)"
  >
    <div class="heading_content">
      <h1>{{ category.name }}</h1>
      <p>{{ category.description }}</p>
    </div>
    <swiper
      [config]="cardSliderConfig"
      class="carousel mySwiper"
      [autoplay]="{ delay: category.slider_duration * 1000 }"
    >
      <ng-template
        swiperSlide
        class="slide"
        *ngFor="let card of category.allies"
      >
        <div class="card">
          <picture>
            <source
              type="image/webp"
              [srcset]="card.image_webp_id"
              alt="Aliado Jelpit"
            />
            <source
              type="image/jp2"
              [srcset]="card.image_jpg200_id"
              alt="Aliado Jelpit"
            />
            <img
              [src]="card.image_id"
              alt="Aliado Jelpit"
              loading="lazy"
              decoding="async"
            />
          </picture>
          <div
            class="card_content"
            [ngStyle]="{ 'border-top': '4px solid ' + card.color_hex }"
          >
            <div class="content_text">
              <h1>{{ card.name }}</h1>
              <p>
                {{
                  card.description.length > 143
                    ? (card.description | slice : 0 : 143) + "..."
                    : card.description
                }}
              </p>
            </div>
            <p class="cities" *ngIf="card.coverage_cities">
              {{
                card.coverage_cities.length > 105
                  ? (card.coverage_cities | slice : 0 : 105) + "..."
                  : card.coverage_cities
              }}
            </p>
            <lib-tb-button
              [custom]="{
                label: card.name_buttom,
                styleBtn: 'stroke',
                typeBtn: 'primary',
                class: 'content_button'
              }"
              (click)="openModal(card, category.name)"
            ></lib-tb-button>
          </div>
        </div>
      </ng-template>
    </swiper>
  </div>
</section>
